import Localization from "sap/base/i18n/Localization";
import FlowComponent from "ips/ac/Component";
import Util from "ips/ac/util/Util";


// TODO cant find any usage
export default class LanguageService {
  private static instance: LanguageService;
  private component:FlowComponent;

  private constructor() {
    this.component = Util.getComponent();
  }

  public static getInstance() {
    if (!LanguageService.instance) {
      LanguageService.instance = new LanguageService();
    }
    return LanguageService.instance;
  }
  public init(component:FlowComponent):void{
    this.component = component;
  }

  public static setLanguage(language:string):void{
    Localization.setLanguage(language);
  }

}